import { type ComponentRef, forwardRef } from "react";

import {
  IconButton as BaseIconButton,
  type IconButtonProps as BaseIconButtonProps,
} from "@radix-ui/themes";

import { semanticColor as semanticColorMapper } from "../styles";
import { cn } from "../util.cn";

interface IconButtonProps extends Omit<BaseIconButtonProps, "variant"> {
  // force developer to make decision to have screen readers (or not)
  screenReaders: string | undefined;
  semanticColor?: keyof typeof semanticColorMapper;
  variant?: "inline-ghost" | BaseIconButtonProps["variant"];
}
type IconButtonRef = ComponentRef<typeof BaseIconButton>;

const IconButton = forwardRef<IconButtonRef, IconButtonProps>((props, ref) => {
  const {
    children,
    className,
    screenReaders,
    variant,
    semanticColor,
    color,
    ...buttonProps
  } = props;

  const iconVariant = variant === "inline-ghost" ? "ghost" : variant;

  return (
    <BaseIconButton
      {...buttonProps}
      className={cn(
        variant === "inline-ghost" && "hotfix--inline-ghost",
        className,
      )}
      ref={ref}
      variant={iconVariant}
      color={(semanticColor && semanticColorMapper[semanticColor]) || color}
    >
      {screenReaders
        ? (
            <div>
              <span className="sr-only">{screenReaders}</span>
              {children}
            </div>
          )
        : children}
    </BaseIconButton>
  );
});
IconButton.displayName = BaseIconButton.displayName;

export { IconButton, type IconButtonProps };
